import { render, staticRenderFns } from "./NovaOsComponent.vue?vue&type=template&id=7d8c8d60&scoped=true&"
import script from "./NovaOsComponent.vue?vue&type=script&lang=js&"
export * from "./NovaOsComponent.vue?vue&type=script&lang=js&"
import style0 from "./NovaOsComponent.vue?vue&type=style&index=0&id=7d8c8d60&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d8c8d60",
  null
  
)

export default component.exports